import { useCallback, useEffect, useRef, useState } from "react";
import { isDeviceHintOTPReauthVisible } from "./deviceHintOTPReauth";
import { useDialogBackButton } from "./useDialogBackButton";
export function useDeviceHintOTPReauth(resetDeviceHintOTP, state) {
    const [showOTPReauth, setShowOTPReauth] = useState(false);
    const resetDeviceHintOTPRef = useRef(resetDeviceHintOTP);
    resetDeviceHintOTPRef.current = resetDeviceHintOTP;
    const closeOTPReauth = useCallback(() => {
        resetDeviceHintOTPRef.current();
        setShowOTPReauth(false);
    }, []);
    const isOTPReauthVisible = isDeviceHintOTPReauthVisible({ showOTPReauth, ...state });
    useEffect(() => {
        if (showOTPReauth && !isOTPReauthVisible) {
            resetDeviceHintOTPRef.current();
            setShowOTPReauth(false);
        }
    }, [showOTPReauth, isOTPReauthVisible]);
    useDialogBackButton(isOTPReauthVisible, closeOTPReauth);
    return { showOTPReauth, setShowOTPReauth, isOTPReauthVisible, closeOTPReauth };
}
